<template>
  <!-- vue-toastification oblige de passer par les balises font-awesome -->
  <font-awesome-icon :icon="['fas', 'circle-exclamation']" class="text-warningPrimary" />
</template>
